module.exports = __webpack_public_path__ + "static/img/1-05-2.8f1e564.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/1-05-2.png
// module id = +bIH
// module chunks = 1